import { Container } from '@repo/ui'
import { observer } from 'mobx-react-lite'

import { AppHeader } from '@/components/AppHeader'
import { BackButton } from '@/components/icon-buttons/IconButtons'
import { List } from '@/components/List'
import { Main } from '@/components/Main'
import { Page } from '@/components/Page'
import { PageHeading } from '@/components/PageHeading'

export const AdminPage = observer(() => {
  return (
    <Page title='Admin'>
      <AppHeader actionsLeft={<BackButton url='/' />} header={<PageHeading>Admin</PageHeading>} />

      <Main>
        <Container className='flex flex-col gap-12' size='medium'>
          <div className='flex flex-col gap-4'>
            <List>
              <List.Item to='/admin/trivia/lists'>Manage Trivia Lists</List.Item>
              <List.Item to='/admin/playlists'>Manage Music Playlists</List.Item>
              <List.Item to='/admin/games'>Active Games</List.Item>
            </List>
          </div>
        </Container>
      </Main>
    </Page>
  )
})
